var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.resources,"size":"small","highlight-row":"","stripe":"","max-height":"700"},scopedSlots:_vm._u([{key:"barcode",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v("\n        "+_vm._s(row.product ? row.product.barcode : 'N/A')+"\n      ")])]}},{key:"product",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v("\n        "+_vm._s(row.product ? row.product.product_name_en : 'N/A')+"\n      ")])]}},{key:"uom",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v("\n        "+_vm._s(row.unite_of_measure ? row.unite_of_measure.uom_name_en : 'N/A')+"\n      ")])]}},{key:"cost",fn:function(ref){
var row = ref.row;
return [_c('ts-display-currency',{attrs:{"amount":row.input_cost,"currency_id":row.input_currency_id}})]}},{key:"discount",fn:function(ref){
var row = ref.row;
return [(row.discount_type == '%')?_c('b',{staticClass:"ts-text-blue-700"},[_vm._v("\n        "+_vm._s(row.discount_rate + ' ' + row.discount_type)+"\n      ")]):_c('div',[_c('ts-display-currency',{attrs:{"amount":row.input_discount_rate,"currency_id":row.input_currency_id}})],1)]}},{key:"fx_rate",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"text-right ts-text-blue-700 ts-font-semibold"},[_vm._v("\n        "+_vm._s(row.fx_rate)+"\n      ")])]}},{key:"total",fn:function(ref){
var row = ref.row;
return [_c('ts-display-currency',{attrs:{"amount":row.input_total_after_discount,"currency_id":row.input_currency_id}})]}},{key:"converted_total",fn:function(ref){
var row = ref.row;
return [_c('ts-display-currency',{attrs:{"amount":row.total_after_discount,"currency_id":row.currency_id}})]}},{key:"max_reorder",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.product.maximum_reorder_allow
          ? row.product.maximum_reorder_allow
          : 0)+"\n    ")]}},{key:"allow_order",fn:function(ref){
          var row = ref.row;
return [(
        row.quantity_order >
        (row.product.maximum_reorder_allow
          ? row.product.maximum_reorder_allow
          : 0)
      )?_c('span',{staticClass:"badge badge-success"},[_vm._v("Yes")]):_c('span',{staticClass:"badge badge-danger"},[_vm._v("No")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }